import React from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  
} from "react-bootstrap"; 
import caims from "../../assets/CopperAluminium-Import-Monitoring-System-1.jpg";

export default function CAIMS() {
//    const [open, setOpen] = useState(0);
  

  return (
    <>
    <div className="bg-light py-5">
    
           <section className="bg-light">
                  <Container>
                    <Row className="g-4 align-items-start">
                      {/* LEFT CONTENT */}
                      <Col lg={8}>
                              <div>
                                <h1>Paper Import Monitoring System</h1>
                                  <Row>
                                        <div className="col-md-6" style={{margin:"auto"}}>
                                            <img src={caims} alt="CAIMS" className="img-fluid b-block mx-auto mb-3" />
                                                                           
                                        </div>
                                    </Row>
                              </div>
                        </Col>
                                <Col lg={4}>
                                             <div className="p-4 shadow rounded right-form">
                                               <Form>
                                                 <Form.Control className="mb-3" placeholder="Name" />
                                                 <Form.Control className="mb-3" placeholder="Email" />
                                                 <Form.Control className="mb-3" placeholder="Phone" />
                                                 <Form.Control className="mb-3" placeholder="Subject" />
                                                 <Button className="w-100">Get Started</Button>
                                               </Form>
                                             </div>
                               </Col>
            </Row>                      
                      
            </Container>
        </section>
        
    </div>
    </>    
  );
}